const AUTH_FORM = 'AUTH_FORM'

export {
  AUTH_FORM
}